const config = {
  MODERNIZATION_PATHS:
    "https://partnercentral.awspartner.com/partnercentral2/s/resources?Id=0698W00000x4c3qQAA",
  MAP_ELIGIBLE_LIST:
    "https://s3-us-west-2.amazonaws.com/map-2.0-customer-documentation/included-services/MAP_Included_Services_List.pdf",
  MODERN_SERVICES_LIST:
    "https://partnercentral.awspartner.com/partnercentral2/s/resources?Id=0698W00000x4c3qQAA",
};

export default config;
